import moment from 'moment';
import {callApi, getApi} from './api';
import {CDC_ACCOUNT_DATA, CDC_ERROR_CODE, CDC_LOCAL_STORE, LOCAL_STORE_POSTCODE, STAFF_CARD_NO} from './constants';
import * as utils from './utils';
import _ from 'lodash';
import {checkLocalStorage} from './findInStore';

export default class CDC {
    constructor($el) {
        this.$el = $el;
        this.$blockQuery = $($el);
        this.successUrl = $(this.$el).attr('success-url');
        this._messageSelecter = '#errorMessageCDC';
        this._site = $('body').hasClass('is-bris') ? 'briscoes' : 'rebel';
        this._extendField = $('body').hasClass('is-bris') ? 'Briscoes' : 'Rebel';
        this._initCDC($el);
        this.$el.cdc = this;
    }

    _initCDC($el) {
        const screenSet = $($el).attr('screen-set');
        const startScreen = $($el).attr('start-screen');
        const containerID = $($el).attr('id');

        startScreen && utils.showScreenSet({
            screenSet,
            startScreen,
            containerID,
            onAfterScreenLoad: typeof this['_onAfterScreenLoad'] === 'function' ? this['_onAfterScreenLoad'].bind(this) : () => {},
            onSubmit: typeof this['_onSubmit'] === 'function' ? this['_onSubmit'].bind(this) : () => {},
            onFieldChanged: typeof this['_onFieldChanged'] === 'function' ? this['_onFieldChanged'].bind(this) : () => {},
            onBeforeValidation: this._customValidation.bind(this),
			onAfterSubmit: typeof this['_onAfterSubmit'] === 'function' ? this['_onAfterSubmit'].bind(this) : () => {},
        });
        this._registerEvent();
    }

    _customValidation(form) {
        const formData = form.formData;
        const beforeValidate = {};

        return new Promise((resolve) => {
            if (typeof this['validate'] !== 'undefined') {
                for (const [key, validates] of Object.entries(this.validate)) {
                    if (typeof formData[key] !== 'undefined') {
                        validates.forEach((validate) => {
                            let value = formData[key];
                            if (typeof validate === 'function') {
                                const errorMessage = validate(form);
                                if (errorMessage) {
                                    beforeValidate[key] = errorMessage;
                                }
                            } else {
                                switch (validate) {
                                    case 'required':
                                        if (utils.isNullOrWhiteSpace(value)) {
                                            beforeValidate[key] = 'This field is required';
                                        }
                                        break;

                                    case 'mobile-number':
                                        if (value) {
                                            if (!(/^[a-zA-Z0-9]*$/).test(value)) {
                                                beforeValidate[key] = 'Please remove any special characters';
                                            } else if (!(/^[0-9]*$/).test(value)) {
                                                beforeValidate[key] = 'Please enter a valid phone number';
                                            } else if (!(/^0[0-9]*$/).test(value)) {
                                                beforeValidate[key] = 'Phone number should begin with 0';
                                            } else if ((/^0[0-9]*$/).test(value) && !(/^.{7,12}$/).test(value)) {
                                                beforeValidate[key] = 'Phone should be within 7 and 12 numbers';
                                            }
                                        }
                                        break;

                                    case 'password':
                                        if (value) {
                                            if (!(/^.{8,}$/).test(value)) {
                                                beforeValidate[key] = 'The password you entered does not meet the minimum length of 8 characters. Please enter a valid password.';
                                            } else if (!(/^.{8,64}$/).test(value)) {
                                                beforeValidate[key] = 'The password you entered exceeds the maximum length of 64 characters. Please enter a valid password.';
                                            } else if (!(/(?=.*[A-Z])/).test(value)) {
                                                beforeValidate[key] = 'The password you entered does not contain at least one uppercase letter. Please enter a valid password.';
                                            } else if (!(/(?=.*[a-z])/).test(value)) {
                                                beforeValidate[key] = 'The password you entered does not contain at least one lowercase letter. Please enter a valid password.';
                                            } else if (!(/(?=.*\d)/).test(value)) {
                                                beforeValidate[key] = 'The password you entered does not contain at least one number. Please enter a valid password.';
                                            }
                                        }
                                        break;

                                    case 'first-name':
                                        if (value) {
                                            if (!(/^.{0,50}$/).test(value)) {
                                                beforeValidate[key] = 'The first name you entered exceeds the maximum length of 50 characters.';
                                            }
                                        }
                                        break;

                                    case 'last-name':
                                        if (value) {
                                            if (!(/^.{0,50}$/).test(value)) {
                                                beforeValidate[key] = 'The last name you entered exceeds the maximum length of 50 characters.';
                                            }
                                        }
                                        break;

									case 'email':
										if (value) {
											if (!(/^(?!.*\.\@)(?!.*[.!#$%&'*+/=?^_`{|}~-]{2})(?!.*[.!#$%&'*+/=?^_`{|}~-]$)(?!^[.!#$%&'*+/=?^_`{|}~-])[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]{1,64}@[a-zA-Z0-9]+([.-]?[a-zA-Z0-9]+)*\.[a-zA-Z]{2,}$/).test(value)) {
												beforeValidate[key] = 'Please enter a valid email address';
											}
										}
										break;

                                    default:
                                        break;
                                }
                            }
                        });
                    }
                }
            }
            resolve(typeof this['_onBeforeValidation'] === 'function' ? this['_onBeforeValidation'].bind(this)(beforeValidate, form) : beforeValidate);
        });
    }

    _registerEvent() {
		window.gigya && window.gigya.socialize.addEventHandlers({
			onAfterResponse: this._onAfterResponse.bind(this),
        });
	}

    _onAfterResponse(data) {
        const {
            methodName,
            response,
        } = data;
        if (typeof this[methodName] === 'function') {
            const promise = new Promise((resolve, reject) => {
                const {errorCode} = response;
                if (errorCode == CDC_ERROR_CODE.SUCCESS) {
                    resolve(data);
                } else {
                    reject(data);
                }
            });
            this[methodName](promise, data);
        }
    }

    _showMessage(message) {
		utils.hideLoading();
        const $message = $(this._messageSelecter);
        if (message && $message.length) {
            $message.html('');
            if (typeof message === 'object') {
                const $ul = $('<ul>');
                $ul.html(message.map((item) => {
                    const $li = $('<li>');
                    $li.text(item);
                    return $li;
                }));
                $message.html($ul);
            } else {
                $message.html(message);
            }
            $message.addClass('is-active');
        }
	}

    _hideMessage() {
        const $message = $(this._messageSelecter);
        $message.removeClass('is-active');
    }

    _showForm() {
        if (this._loading) {
            this._loading.$spinner.hide(0, () => this._loading.$content.show());
        }
    }

    _replaceLink($element, link) {
		$element.length && utils.replaceElemnt($element[0])
			.addEventListener('click', () => {
				window.location.href = link;
			});
	}

    _saveIdToken(token) {
        window.localStorage && window.localStorage.setItem('bris.cdc.token', token);
    }

    _renderFieldError(fieldName, errorCode = 0, message = '') {
        const $form = $(this.$el).find('form[data-screenset-roles]:visible');
        $form.length && $form[0].screenSetInstanceOf[0].renderFieldError({
            errorCode,
            fieldName,
        }, true, message);
    }

    _reset() {
        const $form = $(this.$el).find('form[data-screenset-roles]:visible');
        $form.length && $form[0].reset();
    }

    _renderLocalStore(selected = null, defaults = []) {
        if (utils.enableRenderStore()) {
            const $localStore = $(this.$el).find(`[name="${CDC_LOCAL_STORE[this._site]}"]:visible`);
            if ($localStore.length) {
                const $option = (name, value) => $(`<option value="${value}" data-screenset-element-id-publish="false" data-screenset-roles="instance">${name}</option>`);
                const $optionList = utils.getStoreList(defaults).map((store) => $option(store.name, store.storeId));
                $localStore.html($optionList);
                selected && $localStore.val(selected);
            }
        }
	}
}

export class CdcService {
    constructor() {
        this.site = $('body').hasClass('is-bris') ? 'briscoes' : 'rebel';
    }

    isAvailableLoginID(parameters) {
        return new Promise((resolve, reject) => {
            window.gigya.accounts.isAvailableLoginID(
                _.merge(
                    parameters,
                    {
                        callback: (data) => {
                            this.verifyResponse(data, resolve, reject);
                        },
                    },
                )
            );
        });
    }

    initRegistration(parameters = {}) {
        return new Promise((resolve, reject) => {
            window.gigya.accounts.initRegistration(
                _.merge(
                    parameters,
                    {
                        callback: (data) => {
                            this.verifyResponse(data, resolve, reject);
                        },
                    }
                )
            );
        });
    }

    register(parameters) {
        return new Promise(async (resolve, reject) => {
            const {regToken} = await this.initRegistration();
            window.gigya.accounts.register(
                _.merge(
                    parameters,
                    {
                        regToken,
                        callback: (data) => {
                            this.verifyResponse(data, resolve, reject);
                        },
                    }
                )
            );
        });
    }

    setAccountInfoLite(parameters) {
        return new Promise(async (resolve, reject) => {
            parameters.callback = (data) => {
                this.verifyResponse(data, resolve, reject);
            };
            const {regToken} = await this.initRegistration({isLite: true});
            parameters.regToken = regToken;
            window.gigya.accounts.setAccountInfo(parameters);
        });
    }

    setAccountInfo(parameters) {
        return new Promise(async (resolve, reject) => {
            parameters.callback = (data) => {
                this.verifyResponse(data, resolve, reject);
            };
            window.gigya.accounts.setAccountInfo(parameters);
        });
    }

    setAccountInfoWithToken(parameters) {
        return new Promise(async (resolve, reject) => {
            parameters.callback = (data) => {
                this.verifyResponse(data, resolve, reject);
            };
            const {regToken} = await this.initRegToken();
            parameters.regToken = regToken;
            window.gigya.accounts.setAccountInfo(parameters);
        });
    }

	initRegToken() {
        const {apiKey, defaultApiDomain, dataCenter} = window.gigya;
        const initRegistrationEndpoint = `https://accounts.${dataCenter}.${defaultApiDomain}/accounts.initRegistration?apiKey=${apiKey}&isLite=true`;

		return fetch(initRegistrationEndpoint, {method: 'POST'})
            .then((response) => response.json())
            .then((response) => {
                return Promise.resolve(response);
            });
	}

    updateLocalStore(data) {
        const {storeInfo: {storeId}} = checkLocalStorage();
        const storeIdCDC = _.get(data, 'response.data.localStore' + {briscoes: 'Briscoes', rebel: 'Rebel'}[this.site], 0);

        return new Promise((resolve) => {
            if (storeId && storeId !== storeIdCDC) {
                const parameters = {
                    data: {
                        ['localStore' + {briscoes: 'Briscoes', rebel: 'Rebel'}[this.site]]: storeId,
                    },
                    callback: () => {
                        resolve(data);
                    },
                };
                window.gigya.accounts.setAccountInfo(parameters);
            } else {
                resolve(data);
            }
        });
    }

    verifyLogin() {
        return new Promise((resolve, reject) => {
            window.gigya.accounts.verifyLogin({
                callback: (data) => {
                    this.verifyResponse(data, resolve, reject);
                },
            });
        });
    }

    getJWT() {
        return new Promise((resolve, reject) => {
            window.gigya.accounts.getJWT({
                    callback: (data) => {
                        this.verifyResponse(data, resolve, reject);
                    },
                }
            );
        });
    }

    getAccountInfo() {
		return new Promise(async (resolve, reject) => {
            const {id_token} = await this.getJWT();
			window.gigya.accounts.getAccountInfo({
				include: 'profile,data,preferences, emails',
				extraProfileFields: 'phones', // Default get account info note included phones.
				callback: (data) => {
                    data.idToken = id_token;
                    this.verifyResponse(data, resolve, reject);
				},
			});
		});
	}

    getAccountInfoWithConfig(include = '', extraProfileFields = '') {
		return new Promise((resolve, reject) => {
			window.gigya.accounts.getAccountInfo({
				include: include,
				extraProfileFields: extraProfileFields, // Default get account info note included phones.
				callback: (data) => {
                    this.verifyResponse(data, resolve, reject);
				},
			});
		});
	}

    getAddress() {
        return new Promise((resolve) => {
            this.getAccountInfoWithConfig('data').then((res) => {
                resolve(_.get(res, 'data.address'), []);
            }).catch(() => {
                resolve([]);
            });
        });
    }

    getDeliveryPostcode() {
        return new Promise((resolve, reject) => {
            this.getAddress().then((address) => {
                const shipping = address.find(({shippingDefault}) => shippingDefault);
                if (shipping) {
                    const {postCode} = shipping;
                    if (postCode) {
                        resolve(shipping);
                    }
                } else {
                    reject();
                }
            });
        });
    }

    setDeliveryPostcode(postCode = _.get(window, 'postcodeDelivery.value', '')) {
        window.localStorage && window.localStorage.setItem(LOCAL_STORE_POSTCODE, postCode);
        $('.siteHeader-modalDetail .selected-postcode').html(postCode);
        $('#input-search-postcode').val(postCode);
    }

	getDeliveryGlobalPostcode(postCode = _.get(window, 'postcodeDelivery.value', '')) {
		return window.localStorage.getItem(LOCAL_STORE_POSTCODE) || postCode;
	}

    setStoreById(storeId) {
        return new Promise((resolve) => {
            const parameters = {
                data: {
                    ['localStore' + {briscoes: 'Briscoes', rebel: 'Rebel'}[this.site]]: storeId,
                },
                callback: resolve,
            };
            window.gigya.accounts.setAccountInfo(parameters);
        });
    }

    replaceEmail(responseAccountInfo) {
        const email = _.get(responseAccountInfo, 'profile.email');
        const emails = _.get(responseAccountInfo, 'emails');
        const removeLoginEmails = _.concat(emails.unverified, emails.verified).filter(
            (item) => (item || '').toLocaleLowerCase() !== (email || '').toLocaleLowerCase()
        ).join(',');

        return new Promise((resolve) => {
            if (removeLoginEmails) {
                window.gigya.accounts.setAccountInfo({
                    removeLoginEmails,
                    callback: resolve,
                });
            } else {
                resolve();
            }
        });
    }

    getParameterEmailSubscribe(isEmailSubscribe, profile = null, data = null, site = this.site) {
		const extendField = {
			briscoes: 'Briscoes',
			rebel: 'Rebel',
		};
		const SEND_ME_ALL_THE_EMAILS = 1;
        const parameters = {
			preferences: {
				[site]: {
					communications: {
						email: {
							isConsentGranted: isEmailSubscribe,
						},
					},
				},
			},
            terms: {
                [site]: {
                    isConsentGranted: true,
                },
            },
            privacy: {
                [site]: {
                    isConsentGranted: true,
                },
            },
            data: {
                ['customerBrand' + extendField[this.site]]: true,
                sourceOfLastUpdate: CDC_ACCOUNT_DATA.SOURCE_OF_LAST_UPDATE,
            },
		};

        if (data) {
            parameters.data['customerTypeCode'] = data.customerTypeCode;
            parameters.data['acquisitionChannel' + extendField[site]] = data.acquisitionChannel;
			data[STAFF_CARD_NO] && (parameters.data[STAFF_CARD_NO] = data[STAFF_CARD_NO]);
        }

        if (isEmailSubscribe) {
            parameters.data['emailFrequency' + extendField[this.site]] = SEND_ME_ALL_THE_EMAILS;
        }

        if (profile) {
            parameters.profile = profile;
        }

        return parameters;
    }

    regsiterOpt(parameters) {
        return new Promise((resolve, reject) => {
            callApi('/api/cdc/register/', parameters)
                .then((data) => this.verifyResponse(data, resolve, reject))
                .catch(reject);
        });
    }

    loginOpt(parameters) {
        return new Promise((resolve, reject) => {
            callApi('/api/cdc/login/', parameters)
                .then((data) => this.verifyResponse(data, resolve, reject))
                .catch(reject);
        });
    }

    searchAccountByEmail(email) {
		const getAccountInfoApi = (email) => getApi(`/api/cdc/getaccountinfo?email=${encodeURIComponent(email)}`);

		return new Promise((resolve, reject) => {
			getAccountInfoApi(email).then((data) => {
				const emailToLowerCase = email.toLowerCase();
				if (data || emailToLowerCase === email) {
					return data;
				} else {
					return getAccountInfoApi(emailToLowerCase);
				}
            })
			.then((data) => {
				if (data) {
                    const extendField = {
                        briscoes: 'Briscoes',
                        rebel: 'Rebel',
                    };
                    const response = _.merge(data, data[extendField[this.site]]);
                    resolve(response);
                } else {
					resolve(data);
                }
			})
            .catch(reject);
        });
    }

    verifyResponse(data, callback, fallback) {
        if (data.errorCode === CDC_ERROR_CODE.SUCCESS || data.result == 'SUCCESS') {
            callback(data);
        } else {
            fallback(data);
        }
    }

    overWrite(data, path, fallback) {
       return _.get(data, path, fallback) || fallback;
    }

    pushLastTransactedDate() {
        window.gigya && window.gigya.accounts.setAccountInfo({
            data: {
                lastTransactedDate: moment().format('YYYY-MM-DDTHH:mm'),
                sourceOfLastUpdate: CDC_ACCOUNT_DATA.SOURCE_OF_LAST_UPDATE,
            },
        });
    }

    setAcquisitionChannel(event, accountByEmail, channel, optIn = false) {
        const extendField = {
            briscoes: 'Briscoes',
			rebel: 'Rebel',
		};
        const acquisitionChannel = `acquisitionChannel${extendField[this.site]}`;
        optIn = _.get(event.formModel, `preferences.${this.site}.communications.email.isConsentGranted`, optIn);

        if (accountByEmail.AcquisitionChannel) {
            event.formModel.data[acquisitionChannel] = accountByEmail.AcquisitionChannel;
        } else if (optIn) {
            event.formModel.data[acquisitionChannel] = channel;
        }
    }

    copyDataLiteToFull(event, accountByEmail) {
        const copyBySite = {
            rebel: {
                acquisitionChannelBriscoes: 'Briscoes.AcquisitionChannel',
                customerRegistrationDateBriscoes: 'Briscoes.CustomerRegistrationDate',
                lastTransactedDate: 'LastTransactedDate',
            },
            briscoes: {
                acquisitionChannelRebel: 'Rebel.AcquisitionChannel',
                customerRegistrationDateRebel: 'Rebel.CustomerRegistrationDate',
                lastTransactedDate: 'LastTransactedDate',
            },
        };

        for (const [cdcDataKey, optiDataKey] of Object.entries(copyBySite[this.site])) {
            const optiDataValue = _.get(accountByEmail, optiDataKey);
            if (optiDataValue) {
                event.formModel.data[cdcDataKey] = optiDataValue;
            }
        }
    }
}



// WEBPACK FOOTER //
// ./cdc.js